module.exports = __webpack_public_path__ + "img/games-20.2de68ab5.jpg";